module.exports = __webpack_public_path__ + "img/forte.c1cf2456.jpeg";